import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
}), 'Landscape');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Landscape.js
// module id = 4390
// module chunks = 2